import {Pipe, PipeTransform} from '@angular/core';
import {BotatoMarkdownService} from './botato-markdown.service';

@Pipe({
    name: 'markdown',
    standalone: false
})
export class MarkdownPipe implements PipeTransform {

    constructor(private markdownService: BotatoMarkdownService) {
    }

    public transform(value: string): string {
        return this.markdownService.renderMarkdown(value);
    }
}

